function Teams(){
    return(
        <>
            {/* <section class="m-0 py-5 bg-white position-relative">
                
                <div class="container">
                    <div class="row">
                    <div class="col-md-8 mx-auto text-center">
                        <h4 class="">Our Team</h4>

                    </div>
                    </div>
                    <div class="row mt-lg-5 mt-4">
                    <div data-aos="flip-up" data-aos-duration='200' class="col-lg-3 col-sm-6 mb-4">
                        <div class="card card-body">
                        <div class="row">
                            <div class="col-lg-7">
                            <h6 class="mb-2">Bimash Maharjan</h6>
                            <span class="badge badge-sm rounded-pill mb-3 text-dark">Frontend Designer</span>
                            <br/>
                            <button type="button" class="btn btn-twitter btn-simple px-2 mb-0">
                                <i class="fab fa-twitter text-lg"></i>
                            </button>
                            <button type="button" class="btn btn-dribbble btn-simple px-2 mb-0">
                                <i class="fab fa-dribbble text-lg"></i>
                            </button>
                            <button type="button" class="btn btn-slack btn-simple px-2 mb-0">
                                <i class="fab fa-slack text-lg"></i>
                            </button>
                            </div>
                            <div class="col-lg-5 text-end my-auto">
                            <img class="avatar avatar-xxl" src="https://pub-static.fotor.com/assets/projects/pages/d5bdd0513a0740a8a38752dbc32586d0/fotor-03d1a91a0cec4542927f53c87e0599f6.jpg" />
                            </div>
                        </div>
                        </div>
                    </div>

                    <div data-aos="flip-up" data-aos-duration='300' class="col-lg-3 col-sm-6 mb-4">
                        <div class="card card-body">
                        <div class="row">
                            <div class="col-lg-7">
                            <h6 class="mb-2">Sijan Bhandari</h6>
                            <span class="badge badge-sm rounded-pill mb-3 text-dark">Backend Developer</span>
                            <br/>
                            <button type="button" class="btn btn-facebook btn-simple px-2 mb-0">
                                <i class="fab fa-facebook-f text-lg"></i>
                            </button>
                            <button type="button" class="btn btn-dribbble btn-simple px-2 mb-0">
                                <i class="fab fa-dribbble text-lg"></i>
                            </button>
                            <button type="button" class="btn btn-slack btn-simple px-2 mb-0">
                                <i class="fab fa-slack text-lg"></i>
                            </button>
                            </div>
                            <div class="col-lg-5 text-end my-auto">
                            <img class="avatar avatar-xxl" src="https://pub-static.fotor.com/assets/projects/pages/d5bdd0513a0740a8a38752dbc32586d0/fotor-03d1a91a0cec4542927f53c87e0599f6.jpg" />
                            </div>
                        </div>
                        </div>
                    </div>

                    <div data-aos="flip-up" data-aos-duration='400' class="col-lg-3 col-sm-6 mb-4">
                        <div class="card card-body">
                        <div class="row">
                            <div class="col-lg-7">
                            <h6 class="mb-2">Roshan Maharjan</h6>
                            <span class="badge badge-sm rounded-pill mb-3 text-dark">React Specialist</span>
                            <br/>
                            <button type="button" class="btn btn-twitter btn-simple px-2 mb-0">
                                <i class="fab fa-twitter text-lg"></i>
                            </button>
                            <button type="button" class="btn btn-dribbble btn-simple px-2 mb-0">
                                <i class="fab fa-dribbble text-lg"></i>
                            </button>
                            <button type="button" class="btn btn-github btn-simple px-2 mb-0">
                                <i class="fab fa-github text-lg"></i>
                            </button>
                            </div>
                            <div class="col-lg-5 text-end my-auto">
                            <img class="avatar avatar-xxl" src="https://pub-static.fotor.com/assets/projects/pages/d5bdd0513a0740a8a38752dbc32586d0/fotor-03d1a91a0cec4542927f53c87e0599f6.jpg"/>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div data-aos="flip-up" data-aos-duration='500' class="col-lg-3 col-sm-6 mb-4">
                        <div class="card card-body">
                        <div class="row">
                            <div class="col-lg-7">
                            <h6 class="mb-2">Krisha Maharjan</h6>
                            <span class="badge badge-sm rounded-pill mb-3 text-dark">API Specialist</span>
                            <br/>
                            <button type="button" class="btn btn-twitter btn-simple px-2 mb-0">
                                <i class="fab fa-twitter text-lg"></i>
                            </button>
                            <button type="button" class="btn btn-dribbble btn-simple px-2 mb-0">
                                <i class="fab fa-dribbble text-lg"></i>
                            </button>
                            <button type="button" class="btn btn-github btn-simple px-2 mb-0">
                                <i class="fab fa-github text-lg"></i>
                            </button>
                            </div>
                            <div class="col-lg-5 text-end my-auto">
                            <img class="avatar avatar-xxl" src="https://pub-static.fotor.com/assets/projects/pages/d5bdd0513a0740a8a38752dbc32586d0/fotor-03d1a91a0cec4542927f53c87e0599f6.jpg"/>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </section> */}
            
        </>
    )
}

export default Teams;